import React, { useEffect } from "react";
import { AllTabType } from "src/types/GlobalInterfaces";
import DrawerTitle from "../Drawer/DrawerTitle";
import UserBiomarkers from "../GlobalComponents/HealthProfiles/UserBiomarkers";
import { RootState } from "@store/store";
import { useSelector } from "react-redux";
import UserVitals from "../GlobalComponents/HealthProfiles/UserVitals";

interface IProps {
  onBack: () => void;
  setActiveTab: (tab: AllTabType) => void;
  onClose: () => void;
  id?: string;
  tab?: "Vitals" | "Biomarkers";
}

const MyHealthProfileScreen = ({ onBack, setActiveTab, onClose, id, tab }: IProps) => {
  const { userDetails } = useSelector((store: RootState) => store.appReducer);
  const uid = userDetails?._id || "";

  const [acTab, setAcTab] = React.useState<"Vitals" | "Biomarkers">("Vitals");

  useEffect(() => {
    if (tab) {
      setAcTab(tab);
    }
  }, [tab]);

  return (
    <>
      <DrawerTitle title="My Health Profile" onBack={onBack} backBtn />
      <div className="side-bar-padding">
        {acTab === "Vitals" ? (
          <UserVitals
            activeTab={acTab}
            onClose={onClose}
            setActiveTab={setAcTab}
          />
        ) : (
          <UserBiomarkers
            id={uid}
            isMyProfile={true}
            role={"customer"}
            setActiveTab={setAcTab}
            activeTab={acTab}
            onClose={onClose}
            filterId={id || ""}
            isCustomer={true}
          />
        )}
      </div>
    </>
  );
};

export default MyHealthProfileScreen;
